var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottleNipple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00956 15H4C2.89543 15 2 15.8954 2 17C2 18.1046 2.89543 19 4 19H20C21.1046 19 22 18.1046 22 17C22 15.8954 21.1046 15 20 15H19.9904C19.8622 13.3218 18.4598 12 16.7487 12H16.5355C14.6695 12 13.2361 10.3473 13.5 8.5L13.7172 6.9799C13.8664 5.93492 13.0556 5 12 5C10.9444 5 10.1336 5.93492 10.2828 6.9799L10.5 8.5C10.7639 10.3473 9.33049 12 7.46446 12H7.25126C5.54019 12 4.13783 13.3218 4.00956 15Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottleNipple);
export default __webpack_public_path__ + "static/media/bottle-nipple.8ff88bfefae7b8787da4a1201b5d0526.svg";
export { ForwardRef as ReactComponent };